































import {
  FeedbackDto,
  LanguageDto,
} from "@/server/app.dtos";
import { FeedbackService } from "@/services/api/feedback.service";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class DashboardFeedbackComponent extends Vue {
  @Prop() feedback!: FeedbackDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;

  feedbackService: FeedbackService = new FeedbackService();
  questions: number = 0;
  revisores: number = 0;
  recipients: number = 0;
  comments: number = 0;

  async created() {
    if (this.feedback && this.feedback.idFeedback)
      await this.feedbackService
        .GetStats(this.feedback.idFeedback)
        .then((result) => {
          this.questions = result.questions ?? 0;
          this.revisores = result.revisores ?? 0;
          this.recipients = result.recipients ?? 0;
          this.comments = result.comments ?? 0;
        });
  }
}
